import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoImportDutySNG extends Component {

  render() {
    const { dutes_sng } = this.props;
    const summary = getTitleSummary(dutes_sng)
    return (
      <CodeInfoSection
        title={{
          headers: ['Импортная пошлина для стран СНГ'],
          rows: summary
        }}
        expanded={(dutes_sng.length !== 0) ? true : false}
        table={{
          headers: [
            '',
            'Страна происхождения',
            'Cтрана таможенной очистки',
            'Ставка',
            'Нормативный документ',
            'Комментарий'
          ],
          rows: dutes_sng.map((
            {
              to_date = null,
              joined_origin_country = '',
              customs_clearance_country = '',
              hint = '',
              order,
              order_date,
              orders_info = null,
              description = ''
            }) => ([
              <ToDateNotificator to_date={to_date} />,
              joined_origin_country,
              customs_clearance_country,
              hint,
              formatOrder(order, order_date, orders_info),
              description
            ]))
        }}
      />
    );
  }
}

function getTitleSummary(items) {
  var hint = items.length !== 0 ? items[0].hint : 'нет';
  items.every(function (item, i) {
    if (item.hint !== hint) {
      hint += ' (базовая ставка)';
      return false;
    } else {
      return true;
    }
  });
  return [[hint]];
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoImportDutySNG.js